module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Contents"
    }
  }, [_c('p', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_ListOfPlates"
    }
  }, [_vm._v("List of Plates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Maps"
    }
  }, [_vm._v("List of Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Glossary"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01"
    }
  }, [_vm._v("Chapter 1: The Opposing Armoured Forces in 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1sec1"
    }
  }, [_vm._v("Efficiency Hypothesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1sec2"
    }
  }, [_vm._v("German Armoured Units on the Eastern Front")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1sec3"
    }
  }, [_vm._v("Guderian to the Rescue?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1sec4"
    }
  }, [_vm._v("Armour Deployed to the Western Front")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1sec5"
    }
  }, [_vm._v("North Africa: Reinforcing Failure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1sec6"
    }
  }, [_vm._v("Diversion of Armour to the Waffen-SS and Luftwaffe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1sec7"
    }
  }, [_vm._v("German Tactical and Doctrinal Changes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1sec8"
    }
  }, [_vm._v("German Tank Training")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1sec9"
    }
  }, [_vm._v("Impact of Fuel and Spare Parts Shortages")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1sec10"
    }
  }, [_vm._v("German Tank Production")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1sec11"
    }
  }, [_vm._v("The Red Army’s Tank Forces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1sec12"
    }
  }, [_vm._v("Soviet Tactical and Doctrinal Changes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1sec13"
    }
  }, [_vm._v("Soviet Tank Training")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#ch1sec14"
    }
  }, [_vm._v("Soviet Tank Production and Lend-Lease")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Armoured Operations in 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#ch2sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Retreat from the Caucasus, 1 January–2 February 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#ch2sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The End at Stalingrad, 1 January–2 February 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#ch2sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hoth’s Stand on the Manych River, 1–31 January 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#ch2sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Crisis of Heeresgruppe Don: Gruppe Hollidt, 1 January–14 February 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#ch2sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Destruction of the 2nd Hungarian Army, 12–29 January 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#ch2sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heeresgruppe Mitte’s trials at Rzhev and Velikiye Luki, 1 January–1 March 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#ch2sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Relief of Leningrad: Operation Spark ("), _c('i', [_vm._v("Iskra")]), _vm._v("), 12 January–19 March 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#ch2sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation Gallop ("), _c('b', [_c('i', [_vm._v("Skachok")])]), _vm._v("), 29 January–18 February 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#ch2sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation Star ("), _c('b', [_c('i', [_vm._v("Zvezda")])]), _vm._v("), 1–16 February 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#ch2sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Backhand Blow, 19 February–16 March 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#ch2sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rokossovsky’s Offensive, 25 February–28 March 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#ch2sec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Soviet Offensive in the Kuban, 4 April–7 June 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#ch2sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Building up for the Showdown, April–June 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter02_1#ch2sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation "), _c('b', [_c('i', [_vm._v("Zitadelle")])]), _vm._v(": The Northern Front 5–10 July 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02_2#ch2sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation "), _c('b', [_c('i', [_vm._v("Zitadelle")])]), _vm._v(": The Southern Front, 5–16 July 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02_2#ch2sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Meaning of the Battle of Kursk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02_2#ch2sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation "), _c('b', [_c('i', [_vm._v("Kutusov")])]), _vm._v(", 12 July–18 August 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02_2#ch2sec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mius River Battles, 17 July–2 August 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02_2#ch2sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation Rumyantsev, 3–23 August 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02_2#ch2sec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation "), _c('b', [_c('i', [_vm._v("Suvorov")])]), _vm._v(": the Smolensk Offensive, 7 August–2 October 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02_2#ch2sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Advance to the Dnepr, 24 August–6 November 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02_2#ch2sec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("German Counter-attacks Near Kiev, 7 November-24 December 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Armoured Operations in 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03#ch3sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heeresgruppe Nord retreats from Leningrad, 14 January–1 April 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03#ch3sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Evisceration of Heeresgruppe Süd, January–March 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03#ch3sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Defence of the Dniester Line, 5 April–15 May 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03#ch3sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation Bagration and its Aftermath, 22 June–31 August 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03#ch3sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue, September 1944–May 1945")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Conclusions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix I: Rank Table")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Appendix02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix II: Armour Order of Battle, 1 July 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Appendix03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix III: Tanks on the Eastern Front, 1943–44")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Appendix04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix IV: Tank Production, 1943")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Appendix05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix V: Armour Order of Battle, 21 June 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Appendix06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix VI: Tank Production, 1944")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 63
// module chunks = 0